import React from 'react';
import AdUnit from '../AdUnit';

const SidebarAd = () => (
  <AdUnit
    adSlot="5538539111"
    adFormat="horizontal"
  />
);

export default SidebarAd;
